import { lazy } from "react"

export const Home = lazy(() => import("./home"))
export const NotFound = lazy(() => import("./not-found"))

export const Login = lazy(() => import("./login"))
export const SignUp = lazy(() => import("./sign-up"))

export const TicketPurchaseLayout = lazy(() => import("./ticket/purchase-layout"))
export const TicketPurchase = lazy(() => import("./ticket/purchase"))
export const TicketPurchaseCard = lazy(() => import("./ticket/purchase-card"))
export const TicketPurchaseReturn = lazy(() => import("./ticket/purchase-return"))
export const RestaurantTicketDetail = lazy(() => import("./ticket/detail"))
export const Restaurant = lazy(() => import("./restaurant"))

// Consumer app pages
export const PurchaseDetail = lazy(() => import("./purchases/detail"))
export const PurchaseUse = lazy(() => import("./purchases/use"))
export const PurchaseLog = lazy(() => import("./purchases/index"))
export const AccountSettings = lazy(() => import("./account/index"))
export const UpdateEmail = lazy(() => import("./account/update-email"))
export const UpdatePassword = lazy(() => import("./account/update-password"))
export const CardManagement = lazy(() => import("./account/cards"))

// Auth pages
export const ForgetPassword = lazy(() => import("./login/forget-password"))
export const ForgetPasswordSent = lazy(() => import("./login/forget-password-sent"))
export const ResetPassword = lazy(() => import("./login/reset-password"))

// Guest pages
export const GuestPurchase = lazy(() => import("./guest-purchase"))
export const GuestPurchaseLayout = lazy(() => import("./guest-purchase-layout"))
export const GuestPurchaseCard = lazy(() => import("./guest-purchase-card"))
export const GuestPurchaseReturn = lazy(() => import("./guest-purchase-return"))
export const GuestTicketView = lazy(() => import("./guest-ticket"))
